import { IconComponentsProps } from './types';

const PublishToAtlanIcon = ({ fill = 'currentColor', ...props }: IconComponentsProps) => (
  <svg width="404" height="287" viewBox="0 0 404 287" fill={fill} xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      opacity="0.45"
      d="M193.827 286.354C273.184 286.354 337.515 273.323 337.515 257.248C337.515 241.172 273.184 228.141 193.827 228.141C114.47 228.141 50.1382 241.172 50.1382 257.248C50.1382 273.323 114.47 286.354 193.827 286.354Z"
      fill="#E6E6E6"
    />
    <path
      opacity="0.3"
      d="M126.84 36.0761C78.9841 47.0033 41.1732 81.532 30.1115 125.916C21.8648 158.95 29.107 193.021 84.6141 205.43C204.594 232.249 334.223 223.345 349.798 169.781C365.374 116.217 336.467 24.3416 267.84 18.6551C228.764 15.3902 170.107 26.2331 126.84 36.0761Z"
      fill="#E6E6E6"
    />
    <path
      d="M95.6562 256.639C95.6562 256.639 102.588 247.001 92.2459 244.278C81.9034 241.555 94.7261 228.556 85.1029 226.833C75.4797 225.11 77.0794 238.88 77.0794 238.88C77.0794 238.88 70.4821 233.339 65.8441 238.037C61.2061 242.736 67.6794 247.796 67.6794 247.796C67.6794 247.796 58.4158 250.904 64.1947 256.591L95.6562 256.639Z"
      fill="#E6E6E6"
    />
    <path
      d="M81.7419 257.928C81.7419 257.928 86.1443 250.603 92.6425 251.507C99.1406 252.41 98.4338 257.928 98.4338 257.928H81.7419Z"
      fill="#C9C9C9"
    />
    <path
      d="M59.5283 119.096C59.5254 116.623 58.4054 114.276 56.4647 112.676C54.524 111.076 51.9583 110.384 49.4463 110.783C47.4166 107.083 43.4564 104.768 39.141 104.759H38.707C38.9908 103.688 39.1366 102.588 39.141 101.482C39.141 94.0232 32.917 87.9766 25.2394 87.9766C17.5618 87.9766 11.3378 94.0232 11.3378 101.482C11.3423 102.588 11.4881 103.688 11.7719 104.759H11.3378C5.01734 104.959 0 109.994 0 116.138C0 122.282 5.01734 127.317 11.3378 127.517H51.9761V127.433C56.2875 126.884 59.5155 123.32 59.5283 119.096Z"
      fill="#DCDCDC"
    />
    <path
      d="M403.318 35.4249C403.312 30.1748 398.929 25.9217 393.523 25.9217C392.996 25.9244 392.47 25.969 391.951 26.0549C389.655 21.8996 385.196 19.3046 380.341 19.2991H379.855C380.173 18.0965 380.336 16.8603 380.341 15.6187C380.489 10.0875 377.535 4.91383 372.627 2.10593C367.718 -0.701976 361.628 -0.701976 356.719 2.10593C351.81 4.91383 348.857 10.0875 349.005 15.6187C349 16.8839 349.159 18.1446 349.48 19.3708H348.994C341.913 19.646 336.318 25.3019 336.318 32.1854C336.318 39.0689 341.913 44.7248 348.994 45H394.801V44.9077C399.696 44.287 403.349 40.2205 403.318 35.4249Z"
      fill="#DCDCDC"
    />
    <path
      d="M346.773 76.9844L349.597 84.4002L357.228 87.1443L349.597 89.8884L346.773 97.3042L343.95 89.8884L336.318 87.1443L343.95 84.4002L346.773 76.9844Z"
      fill="#4A7DFF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M293.5 165.75L281.867 176.854L219.25 117.161V260.25H202.75V117.161L140.132 176.854L128.5 165.75L211 87L293.5 165.75ZM293.5 39.75C297.876 39.7501 302.073 41.4096 305.167 44.3633C308.261 47.317 310 51.3229 310 55.5V87H293.5V55.5H128.5V87H112V55.5C112 51.323 113.738 47.3169 116.832 44.3633C119.927 41.4096 124.124 39.75 128.5 39.75H293.5Z"
      fill="#1010EB"
    />
  </svg>
);

export default PublishToAtlanIcon;
